import { useEffect, useRef } from "react";
import { api } from "./api";

/**
 * Polls /api/reminders/upcoming every 60 s and fires a browser notification
 * for each new lead due in the next 15 minutes. Uses sessionStorage to make
 * sure each lead only pings the user once per session.
 */
export function useFollowUpReminders(enabled) {
  const notifiedRef = useRef(new Set(JSON.parse(sessionStorage.getItem("gb_notified") || "[]")));

  useEffect(() => {
    if (!enabled) return;
    if (typeof window === "undefined" || !("Notification" in window)) return;

    // Ask permission once
    if (Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }

    let cancelled = false;

    const tick = async () => {
      if (cancelled) return;
      try {
        const r = await api.get("/reminders/upcoming?minutes=15");
        if (Notification.permission !== "granted") return;
        for (const lead of (r.data.items || [])) {
          if (notifiedRef.current.has(lead.id)) continue;
          notifiedRef.current.add(lead.id);
          try {
            const due = new Date(lead.next_followup_at);
            const time = due.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            const n = new Notification("Follow-up due soon", {
              body: `${lead.customer_name} (${lead.lead_code}) — ${lead.project_interested || "call"} · ${time}`,
              tag: `gb-lead-${lead.id}`,
            });
            n.onclick = () => {
              window.focus();
              window.location.href = `/leads/${lead.id}`;
            };
          } catch { /* ignore */ }
        }
        sessionStorage.setItem("gb_notified", JSON.stringify(Array.from(notifiedRef.current)));
      } catch { /* silent */ }
    };

    tick();
    const id = setInterval(tick, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, [enabled]);
}
